// extracted by mini-css-extract-plugin
export var footer = "_ln-5";
export var fulfillmentInput = "_ln-0";
export var shipDateInput = "_ln-1";
export var shipmentModal = "_ln-2";
export var shipmentModalContent = "_ln-3";
export var tableContainer = "_ln-4";